<div class="flex flex-row flex-wrap justify-start gap-4">
    <span class="mt-1 text-gray-500">Reserva <span class="font-bold"> {{ getCodigoReserva()}}</span></span>
    <span class="mt-1 text-gray-500">Empreendimento <span class="font-bold"> {{getEmpreendimento()
        }}</span></span>
  <span class="mt-1 text-gray-500">Número <span class="font-bold"> {{ getUnidade() }} </span></span>
</div>
